import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vue2-animate/dist/vue2-animate.min.css";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import VueMoment from "vue-moment";
import moment from "moment";
import rutjs from "rut.js";
import VueAxios from "vue-axios";
import SweetAlertIcons from "vue-sweetalert-icons";
import VueGeolocation from "vue-browser-geolocation";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw/dist/leaflet.draw.js";
require("moment/locale/es");
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "leaflet-bing-layer/leaflet-bing-layer.js";
import infiniteScroll from "vue-infinite-scroll";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css";
import "leaflet-defaulticon-compatibility";
import VueGtag from "vue-gtag";

// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl;
// eslint-disable-next-line
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("@/assets/cp-map-marker.png"),
  iconUrl: require("@/assets/cp-map-marker.png"),
  iconSize: [50, 50],
  iconAnchor: [50, 50]
});

import api from "./api.js";
import VueApexCharts from "vue-apexcharts";
import "./registerServiceWorker";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueAwesomeSwiper);
Vue.use(VueGeolocation);
Vue.use(SweetAlertIcons);
Vue.use(infiniteScroll);
Vue.use(VueMoment, {
  moment
});

process.env.NODE_ENV === "production" &&
  Vue.use(
    VueGtag,
    {
      config: { id: "UA-178382764-1" }
    },
    router
  );

// Set API URL
axios.defaults.baseURL = api.baseURL;
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.prototype.$rutjs = rutjs;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
